import authAxios from '@/shared/api/authAxios'
import { credentialsApi } from '@/shared/api/config'
import { SystemType } from '@/app/store/systemStore'

export interface Credential {
  userId?: string
  name?: string
  login?: string
  password?: string
}

interface CredentialResponse {
  UserId?: string
  Name?: string
  Login?: string
  Password?: string
}

export const fetchCredentials = async (
  system: SystemType,
  accountId: string,
  cryptoKey: string
): Promise<Credential[]> => {
  const params = new URLSearchParams({
    sourceSystem: system ?? '',
    accountId,
    cryptoKey,
  })

  const { data } = await authAxios.get<CredentialResponse[]>(
    `${credentialsApi}/public/Credentials?${params.toString()}`,
    { timeout: 30000 }
  )

  return data.map((item) => ({
    userId: item.UserId,
    name: item.Name,
    login: item.Login,
    password: item.Password,
  }))
}
